import { memo } from 'react';
import Link from 'next/link';
import styled from 'styled-components';

import FormattedDate from '@components/FormattedDate/FormattedDate';

const Wrapper = styled.div`
  color: var(--theme-color-grey3);
  margin: 0 auto 2rem;
  text-align: center;
`;

const Dot = styled.span`
  color: var(--theme-color-section);
  display: inline-block;
  font-weight: bold;
  margin: 0 0.5rem;
`;

const Anchor = styled.a`
  color: var(--theme-color-grey3);
  font-weight: 400;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const MetaDetails = ({ dt, dtLabel, section }) => {
  const url = `/${section.toLowerCase()}`;

  return (
    <Wrapper>
      <Link href={url} passHref legacyBehavior>
        <Anchor>{section}</Anchor>
      </Link>
      <Dot>&bull;</Dot>
      <FormattedDate dt={dt} label={dtLabel} />
    </Wrapper>
  );
};

export default memo(MetaDetails);
